export const LocationIcon = ({
  width = '12',
  height = '12',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00008 0.166626C4.07508 0.166626 2.50008 1.74163 2.50008 3.66663C2.50008 6.69996 6.00008 10.1416 6.00008 10.1416C6.00008 10.1416 9.50008 6.64163 9.50008 3.66663C9.50008 1.74163 7.92508 0.166626 6.00008 0.166626ZM6.00008 2.44163C6.64175 2.44163 7.22508 3.02496 7.22508 3.66663C7.22508 4.36663 6.70008 4.89163 6.00008 4.89163C5.30008 4.89163 4.77508 4.30829 4.77508 3.66663C4.77508 2.96663 5.35842 2.44163 6.00008 2.44163ZM2.96675 7.80829C2.20842 7.98329 1.62508 8.15829 1.10008 8.39163C0.866748 8.50829 0.633415 8.68329 0.458415 8.85829C0.283415 9.03329 0.166748 9.38329 0.166748 9.67496C0.166748 10.1416 0.458415 10.4916 0.808415 10.725C1.15841 10.9583 1.56675 11.1333 2.09175 11.3083C3.14175 11.6583 4.48342 11.8333 6.00008 11.8333C7.51675 11.8333 8.85842 11.6583 9.90842 11.3666C10.4334 11.1916 10.8417 11.0166 11.1917 10.7833C11.5417 10.55 11.8334 10.2 11.8334 9.73329C11.8334 9.14996 11.3667 8.74163 10.9001 8.44996C10.4334 8.15829 9.79175 7.98329 9.03342 7.86663L8.85841 9.03329C9.50008 9.14996 10.0251 9.32496 10.3751 9.49996C10.6084 9.61663 10.6667 9.73329 10.7251 9.73329C10.7251 9.73329 10.6667 9.79163 10.6084 9.84996C10.4334 9.96663 10.0834 10.1416 9.67508 10.2583C8.68341 10.4916 7.40008 10.6666 6.00008 10.6666C4.60008 10.6666 3.31675 10.4916 2.44175 10.2C2.03341 10.0833 1.68341 9.90829 1.50841 9.79163C1.45008 9.73329 1.39175 9.67496 1.39175 9.67496C1.45008 9.61663 1.50841 9.55829 1.68341 9.44163C2.03341 9.26663 2.55841 9.09163 3.25841 8.97496L2.96675 7.80829Z"
        fill="#333333"
      />
    </svg>
  );
};
